<template>

<v-dialog v-model="dialog" width="1250px">
  <v-card>
    <v-card-title class="text-h5 grey lighten-2">
                              Photo Assignments {{this.huis_code }}
                              <v-spacer></v-spacer><v-btn class="primary mx-2" small @click="addHsfo" :loading="uploading"><v-icon left>mdi-plus</v-icon>Add assignment</v-btn>
                            </v-card-title>
    
    <v-form ref="addHsft" v-model="addHsftValid">
      <v-data-table 
                    :items="hsfo" 
                    :headers="headers" 
                    :disable-pagination=true 
                    no-data-text="No assignments to display" 
                    :hide-default-footer="true" 
                >
            <template v-slot:item="props">
                <tr>
                <td>
                  <v-chip :color='statuscolor[props.item.hsfo_status]'>{{ props.item.hsfo_status }}</v-chip>
                </td>
                <td>
                    <v-chip :color='priocolor[props.item.hsfo_prio]'>{{ props.item.hsfo_prio }}</v-chip>
                </td>
                <td>  
                  <v-chip class="ma-1" v-for="(hfot, hfotidx) in props.item.hfot" :key="hfotidx" :color='statuscolor_hfot[hfot.hfot_status]'>{{ hfot.hfot_type }}</v-chip>

                </td>
                <td> {{ props.item.hsfo_inv_dat }} </td>
                <td> {{ props.item.hsfo_deadline }} </td>
                <td> {{ props.item.hsfo_fotograaf }} </td>
                <td><v-btn color="primary mx-2" @click="viewHsfo(props.item.hsfo_encrid)" small icon><v-icon>mdi-pencil</v-icon></v-btn>
                    <v-btn color="primary" @click="deleteHsfo(props.item.hsfo_encrid)" small icon><v-icon>mdi-trash-can-outline</v-icon></v-btn>
                </td>
                </tr> 
            </template>

        </v-data-table>
      



     <!-- 
     <v-row no-gutters>
      <v-col class="ma-2">
       <v-select v-model="photographer_active" required :items="photographer_choices" item-value="gebr_code" item-text="gebr_naam" label="Photographer"></v-select>
      </v-col>
     </v-row>  

     <v-row no-gutters>
      <v-col class="ma-2">
       <v-select v-model="contact_active" required :items="contact_choices" item-value="eign_code" item-text="eign_naam" label="Contact"></v-select>
      </v-col>
     </v-row>  
     -->
    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <!-- <v-btn class="primary mx-2" small @click="addPhotographer" :loading="uploading">Save</v-btn> -->
      <v-btn color="primary"  small @click="dialog = false" :disabled="uploading">Close</v-btn>
    </v-card-actions>
  </v-card>
  <addHsfo ref="addHsfo" @updateData="updateData"></addHsfo>
  <viewHsfo ref="viewHsfo" @updateData="updateData"></viewHsfo>
  <deleteHsfo ref="deleteHsfo" @updateData="updateData"></deleteHsfo>
</v-dialog>
</template>

<script>

// import {bus} from "../../../main";
import addHsfo from "@/views/huis/hsfo/addHsfo.vue";
import viewHsfo from "@/views/huis/hsfo/viewHsfo.vue";
import deleteHsfo from "@/views/huis/hsfo/deleteHsfo.vue";
export default {
  components: { 
    addHsfo,
    viewHsfo,
    deleteHsfo
  },
  data() { 
    return {
      hsfo: [],
      dialog: false,
      addHsftValid: false,
      photographer_active: null,
      photographer_choices: [],
      contact_active: null,
      contact_choices: [],
      uploading: false,
      huis_encrid: null,
      huis_code: null,
      fttg_nrKeuzes: [],
      hsft_foto: null,
      hsft: {},
      url: null,
      image:{
        size:'',
        height:'',
        width:'',
        src: null
      },
      fttg_nrRules: [
          v => !!v || "A Tag is required"
      ],
      hsft_fotoRules: [
          v => !!v || "A photo is required"
      ],
      priocolor: {
        Low: '#D1E2FF',
        Medium: '#74EBE1',
        High: '#DC043B'
      },
      statuscolor: {
        Signedup: '#FAD2FC',
        Readytoshoot: '#FFEAB6',
        Offered: '#D1E2FF',
        Assigned: '#88DBFF',
        Completed: '#9AE095',
        Rejected: '#41454D',
        Onhold: '#FFB68E'
      },
      statuscolor_hfot: {
        Notapplicable: '#DC043B',
        Pending: '#D1E2FF',
        Completed: '#9AE095'
      },
      headers: [
              { text: 'Status', value: 'hsfo_status', sortable: false, align: 'start' },
              { text: 'Priority', value: 'hsfo_prio', sortable: false, align: 'start' },
              { text: 'Tasks', value: 'tasks', sortable: false, align: 'start' },
              { text: 'Date Request', value:'request_date'},
              { text: 'Deadline', value: 'deadline', sortable: false, align: 'start' },
              { text: 'Photographer', value: 'hsfo_fotograaf', sortable: false, align: 'start' },
              
              { text: '', value:'actions'},
            ],
    }
  },
  mounted() {   /* Work around voor Safari */
     let inputs = document.querySelectorAll('.v-file-input input');
         [...inputs].forEach((input) => {
              input.remove()
          })
  },
  methods: {
    open(huis_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.url = null;
      this.hsft_foto = null;
      this.huis_encrid = huis_encrid;
      this.$axios
        .post("ares/json/ares/huis/hsfo/getHuisHsfo.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuisHsfo"
          },
          getHuisHsfo: {
            huis_encrid: huis_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.huis_code = res.data.getHuisHsfo.huis_code;
            this.photographer_choices = res.data.getHuisHsfo.photographer_choices;
            this.photographer_active = res.data.getHuisHsfo.photographer_active;
            this.contact_choices = res.data.getHuisHsfo.contact_choices;
            this.contact_active = res.data.getHuisHsfo.contact_active;
            this.hsfo = res.data.getHuisHsfo.hsfo;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addPhotographer() {
      this.$axios
        .post("ares/json/ares/huis/hsft/addPhotographer.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "addPhotographer"
          },
          addPhotographer: {
            huis_encrid: this.huis_encrid,
            photographer_active: this.photographer_active,
            contact_active: this.contact_active,
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
            //  if (res.data.addHsft.color == "success") {
            //     //this.$router.reload('/huis/onHuis/' + res.data.addHsft.huis_encrid);  
            //     bus.$emit("closeDialog", "reload");
            //  }
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.addPhotographer.text,
              color: res.data.addPhotographer.color
            }); 
            this.dialog = false;
          }
        })
    },
    addHsfo() {
      this.$refs.addHsfo.open(this.huis_encrid);
    },
    viewHsfo(hsfo_encrid) {
      this.$refs.viewHsfo.open(hsfo_encrid);
    },
    deleteHsfo(hsfo_encrid) {
      this.$refs.deleteHsfo.open(hsfo_encrid);
    },
    updateData() {
      this.loading = true;
      this.$axios
        .post("ares/json/ares/huis/hsfo/getHuisHsfo.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuisHsfo"
          },
          getHuisHsfo: {
            huis_encrid: this.huis_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hsfo = res.data.getHuisHsfo.hsfo;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  }
}
</script>

